import {combineReducers} from 'redux';
import { filterActions } from 'redux-ignore';
import logSlowReducers from 'redux-log-slow-reducers';
import { reducer as form } from 'redux-form';

import restaurantCode from './restaurantCode.reducer';
import template from './template.reducer';
import language from './language.reducer';
import basket from './basket.reducer';
import basketItem from './basketItem.reducer';
import order from './order.reducer';
import loading from './loading.reducer';
import checkoutData from './checkoutData.reducer';
import errors from './error.reducer';
import tableBooking from './tableBooking.reducer';
import orderSource from './orderSource.reducer';
import serverOffline from './serverOffline.reducer';
import upSelling from './upSelling.reducer';

const rootReducer = combineReducers(logSlowReducers({
  restaurantCode: filterActions(restaurantCode, (action) => action.type.match(/^RESTAURANT\./)),
  template: filterActions(template, (action) => action.type.match(/^TEMPLATE\./)),
  language: filterActions(language, (action) => action.type.match(/^LANGUAGE\./)),
  order: filterActions(order, (action) => action.type.match(/^ORDER\./)),
  loading: filterActions(loading, (action) => action.type.match(/^LOADING\./)),
  basket: filterActions(basket, (action) => action.type.match(/^BASKET\./)),
  basketItem: filterActions(basketItem, (action) => action.type.match(/^BASKET_ITEM\./)),
  errors: filterActions(errors, (action) => action.type.match(/^ERROR\./)),
  orderSource: filterActions(orderSource, (action) => action.type.match(/^ORDER_SOURCE\./)),
  checkoutData,
  form,
  tableBooking: filterActions(tableBooking, (action) => action.type.match(/^BOOKING\./)),
  serverOffline: filterActions(serverOffline, (action) => action.type.match(/^SERVER\./)),
  upSelling: filterActions(upSelling, (action) => action.type.match(/^UPSELLING\./))
}));

export default rootReducer;



// WEBPACK FOOTER //
// ./reducers/index.reducer.js